import { FormattedMessage } from 'react-intl';

import { Props as FormattedMessageProps } from 'react-intl/src/components/message';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionDetails, AccordionSummary, Typography, Link, AccordionProps } from '@mui/material';

interface QuestionEntryProps extends Omit<AccordionProps, 'children'> {
  question: FormattedMessageProps;
  description: FormattedMessageProps;
  link?: string;
}

export const QuestionEntry = ({ question, description, link, sx, ...rest }: QuestionEntryProps) => (
  <Accordion
    sx={{
      backgroundColor: 'background.default',
      '&.Mui-expanded::before': { opacity: 'initial' },
      '&.Mui-expanded .title': { fontWeight: 'semibold' },
      ...sx,
    }}
    {...rest}
  >
    <AccordionSummary expandIcon={<ExpandMoreIcon sx={{ color: 'gray.500' }} />}>
      <Typography className="title">
        <FormattedMessage {...question} />
      </Typography>
    </AccordionSummary>
    <AccordionDetails>
      <Typography>
        <FormattedMessage {...description} />
      </Typography>
      {link && (
        <Link display="inline-block" href={link} target="_blank" mt={2}>
          <Typography variant="h6">
            <FormattedMessage id="learn-more" defaultMessage="Learn More" />
          </Typography>
        </Link>
      )}
    </AccordionDetails>
  </Accordion>
);
